import {LoginEffects} from './login.effects';

export const effects = [
    LoginEffects
];

export * from './login.effects';
